// extracted by mini-css-extract-plugin
export default {"settings":"AdminSettings_settings__FXDA5"};